import { isEmpty } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import SignaturePad from 'react-signature-canvas';
import { toast } from 'react-toastify';
import { BASE_URL } from '../../components/App';
import {
  getConditionalFieldValue,
} from '../../helpers/dynamicFormFields';

let optIndex = 0;
const Radio = (props) => {
  const [LSUserRole, setLSUserRole] = useState(localStorage.getItem("user_role"));
  const { ...controls } = props;
  const [optionValue, setOptionValue] = useState('');
  const [Index, setIndex] = useState(0);
  const [textInputValue, setTextInputValue] = useState('');
  const [array, setArray] = useState([]);
  const [event, setEvent] = useState();
  const [signature, setSignature] = useState(null);
  const [fileList, setFileList] = useState('');
  const [dropDownValue, setDropDownValue] = useState();
  const toSentenceCase = (text) => {
    if (!text || typeof text !== 'string') return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  const sigPad = useRef({});
  let extData = {};
  if (props?.field_data && Object?.keys(props?.field_data)?.length) {
    extData = props?.extra_data;
  }

  const clear = (e) => {
    e.preventDefault();
    sigPad.current.clear();
  };

  const trim = (e) => {
    e.preventDefault();
    props.onChange(
      `${Object.values(eval(controls?.option)[Index])[0]?.field_name} ${
        props?.field_name
      }`,
      sigPad.current.getTrimmedCanvas().toDataURL('image/png')
    );
    if (props?.field_data || signature) {
      setSignature(sigPad?.current?.getTrimmedCanvas()?.toDataURL('image/png'));
      sigPad?.current?.clear();
    }
    toast.success('Signature added.');
  };

  useEffect(() => {
    if (props.errorFocus) {
      document.getElementById(props.errorFocus).focus();
    }
  }, []);

  useEffect(() => {
    if (
      props !== {} &&
      props?.field_data &&
      props?.fieldData !== {} &&
      !isEmpty(props?.field_data) &&
      Object.values(eval(controls?.option)[Index])[0]?.field_type ===
        'signature'
    ) {
      setSignature(
        props?.field_data?.fields[
          Object.values(eval(controls?.option)[Index])[0]?.field_name
        ]
      );
    }
  }, [signature]);

  useEffect(() => {
    if (
      signature &&
      props !== {} &&
      props?.field_data &&
      Object.values(eval(controls?.option)[Index])[0]?.field_type ===
        'signature'
    ) {
      sigPad?.current?.fromDataURL(signature);
    }
  }, [signature]);

  useEffect(() => {
    if (
      typeof controls.field_data !== 'undefined' &&
      Object.keys(controls.field_data).length > 0 &&
      Object.values(eval(controls.option)[Index])[0]?.field_type ===
        'dropdown_selection'
    ) {
      let val =
        props?.field_data?.fields[
          `${Object.values(eval(controls.option)[Index])[0]?.field_name}`
        ];
      let availableOptions = Object.values(eval(controls.option)[Index])[0]
        ?.option;
      let data = {};
      availableOptions.forEach((d, index) => {
        data = { ...data, ...d };
      });
      let valueSelected = Object.keys(data).filter((d) => d === val);
      setDropDownValue(valueSelected[0]);
    }
  }, [Index]);

  useEffect(() => {
    const savedFields = props?.field_data?.fields;
    const parentFieldName = controls?.field_name;

    if (!savedFields || !parentFieldName) {
      if (!props?.field_data?.form_id) {
        setOptionValue('');
        setIndex(0);
      }
      return;
    }

    const parentValue = savedFields[parentFieldName];
    let matchedIndex = 0;

    if (parentValue !== undefined && parentValue !== null && parentValue !== '') {
      const normalizedParentValue = String(parentValue);
      setOptionValue(normalizedParentValue);

      eval(controls.option)?.forEach((item, index) => {
        const key = Object?.keys(item)?.[0];
        if (key === normalizedParentValue) {
          matchedIndex = index;
        }
      });
      setIndex(matchedIndex);
    } else {
      let savedConditionalIndex = -1;
      eval(controls.option)?.forEach((item, index) => {
        const conditionalField = Object.values(item)?.[0];
        if (!conditionalField?.field_name) {
          return;
        }
        const val = getConditionalFieldValue(
          savedFields,
          conditionalField.field_name,
          parentFieldName
        );
        if (val !== undefined && val !== null && val !== '') {
          savedConditionalIndex = index;
        }
      });
      if (savedConditionalIndex >= 0) {
        matchedIndex = savedConditionalIndex;
        setIndex(savedConditionalIndex);
      }
    }

    const conditionalFieldName =
      Object.values(eval(controls?.option)[matchedIndex])?.[0]?.field_name;
    if (conditionalFieldName) {
      let conditionalFieldData = getConditionalFieldValue(
        savedFields,
        conditionalFieldName,
        parentFieldName
      );
      if (typeof conditionalFieldData === 'object') {
        conditionalFieldData = conditionalFieldData?.join(',');
      }
      if (conditionalFieldData) {
        setArray(
          String(conditionalFieldData)
            .split(',')
            .filter((item) => item !== '')
        );
      } else {
        setArray([]);
      }
    }
  }, [props?.field_data, controls?.field_name, controls?.option]);

  useEffect(() => {
    if (
      window.location.pathname.split('/')[2] !== 'preview' &&
      Object.values(eval(controls.option)[Index])[0]['field_type'] ===
        'checkbox'
    ) {
      props.onChange(event, array?.join(','));
    }
  }, [array]);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const uploadFile = async (file) => {
    let type = file.name.split('.')[file.name.split('.').length - 1];
    if (
      Object.values(eval(controls?.option)[Index])[0]?.field_type ===
        'document_attachment' &&
      !(
        type.includes('doc') ||
        type.includes('docx') ||
        type.includes('html') ||
        type.includes('htm') ||
        type.includes('odt') ||
        type.includes('xls') ||
        type.includes('xlsx') ||
        type.includes('ods') ||
        type.includes('ppt') ||
        type.includes('pptx') ||
        type.includes('pdf') ||
        type.includes('txt')
      )
    ) {
      toast.error('File must be DOC, PDF, TXT, XLS, or PPT.');
      return null;
    } else if (
      Object.values(eval(controls?.option)[Index])[0]?.field_type ===
        'image_upload' &&
      !(
        type.includes('jpg') ||
        type.includes('jpeg') ||
        type.includes('png') ||
        type.includes('psd')
      )
    ) {
      toast.error('Image must be JPG, PNG, or PSD.');
      return null;
    } else if (file.size > 2048 * 1024) {
      toast.error('File is too large. File limit 2 MB.');
      return null;
    } else {
      const body = new FormData();
      const blob = await fetch(await toBase64(file)).then((res) => res.blob());
      body.append('image', blob, file.name);
      body.append('description', 'form module');
      body.append('title', 'image');
      body.append('uploadedBy', 'vaibhavi');
      var myHeaders = new Headers();
      myHeaders.append('shared_role', 'admin');
      let res = await fetch(`${BASE_URL}/uploads/uiFiles`, {
        method: 'post',
        body: body,
        headers: myHeaders,
      });
      let data = await res.json();
      toast.success('uploaded.');
      return data?.url;
    }
  };

  const hasValue = (value) => {
    let hasValue = false;
    eval(controls.option)?.forEach((item, index) => {
      let key = Object?.keys(item);
      if (key?.[0] === value) {
        hasValue = true;
      }
    });

    // setIndex(optIndex);
    return hasValue;
  };

  const getMergedFields = () => ({
    ...(props?.extra_data || {}),
    ...(props?.field_data?.fields || {}),
  });

  const hasConditionalValue = (conditionalFieldName) => {
    const conditionalValue = getConditionalFieldValue(
      getMergedFields(),
      conditionalFieldName,
      controls?.field_name
    );
    return (
      conditionalValue !== undefined &&
      conditionalValue !== null &&
      conditionalValue !== ''
    );
  };

  const hasSavedConditionalValue = () =>
    eval(controls.option)?.some((item) => {
      const conditionalField = Object.values(item)?.[0];
      if (typeof conditionalField !== 'object' || !conditionalField?.field_name) {
        return false;
      }
      return hasConditionalValue(conditionalField.field_name);
    });

  const getConditionalIndexFromSavedValue = () => {
    const matchedIndex = eval(controls.option)?.findIndex((item) => {
      const conditionalField = Object.values(item)?.[0];
      if (typeof conditionalField !== 'object' || !conditionalField?.field_name) {
        return false;
      }
      return hasConditionalValue(conditionalField.field_name);
    });

    return matchedIndex >= 0 ? matchedIndex : -1;
  };

  const getSavedParentRadioValue = () => {
    const fromFields = props?.field_data?.fields?.[controls?.field_name];
    if (fromFields !== undefined && fromFields !== null && fromFields !== '') {
      return String(fromFields);
    }
    return optionValue || '';
  };

  const isParentRadioSelected = (optionKey) =>
    getSavedParentRadioValue() === optionKey;

  const handleParentRadioChange = (e, index) => {
    const value = e.target.value;
    setOptionValue(value);
    props.onChange(e.target.name, value, 'radio');
    setIndex(index);
    setArray([]);
    setTextInputValue('');
    setFileList('');
    setSignature(null);
    setDropDownValue(undefined);
  };

  const isEditMode = Boolean(props?.field_data?.form_id || props?.field_data?.id);

  const getSavedConditionalFieldValue = (childFieldName) =>
    getConditionalFieldValue(
      props?.field_data?.fields || {},
      childFieldName,
      controls?.field_name
    );

  const isRadioDisabled = () =>
    (props?.currentForm[0]?.form_permissions[0]?.fill_access_users === null &&
      !props?.form_field_permissions[0]?.fill_access_users?.includes(
        LSUserRole === 'guardian' ? 'parent' : LSUserRole
      )) ||
    (props?.currentForm[0]?.form_permissions[0]?.fill_access_users &&
      !props?.currentForm[0]?.form_permissions[0]?.fill_access_users?.includes(
        LSUserRole === 'guardian' ? 'parent' : LSUserRole
      ) &&
      !props?.form_field_permissions[0]?.fill_access_users?.includes(
        LSUserRole === 'guardian' ? 'parent' : LSUserRole
      )) ||
    props.isDisable;

  useEffect(() => {
    const currentValue = props?.field_data?.fields?.[controls?.field_name];
    if (!currentValue) {
      const matchedIndex = getConditionalIndexFromSavedValue();
      if (matchedIndex >= 0) {
        setIndex(matchedIndex);
      }
    }
  }, [props?.field_data, props?.extra_data, controls?.field_name]);

  return (
    <>
    {/* {JSON.stringify(props)} */}
      <Col sm={6}>
        <Form.Group className="form-input-section">
          <Form.Label id={controls.field_name}>
            {toSentenceCase(controls.field_label)}
          </Form.Label>
          <div
            className="new-form-radio flex_wrap_radio"
            key={`${controls.field_name}-${getSavedParentRadioValue()}`}
          >
            {eval(controls.option)?.map((item, index) => {
              const optionKey = Object.keys(item)[0];
              const radioId = optionKey + props?.diff_index;
              const isSimpleOption =
                Object.keys(eval(controls?.option)[index])[0] ===
                Object.values(eval(controls?.option)[index])[0];

              if (isSimpleOption) {
                return (
                    <div key={optionKey || index} className="new-form-radio-box">
                      <label htmlFor={radioId}>
                        <input
                          type="radio"
                          // defaultChecked={true}
                          value={optionKey}
                          disabled={isRadioDisabled()}
                          name={controls.field_name}
                          id={radioId}
                          onChange={(e) => handleParentRadioChange(e, index)}
                          checked={isParentRadioSelected(optionKey)}
                        />
                        <span className="radio-round"></span>
                        <p>{optionKey}</p>
                      </label>
                    </div>
                );
              }

              return (
                      <div key={optionKey || index} className="new-form-radio-box">
                        <label htmlFor={radioId}>
                          <input
                            type="radio"
                            value={optionKey}
                            disabled={isRadioDisabled()}
                            name={controls.field_name}
                            id={radioId}
                            onChange={(e) => handleParentRadioChange(e, index)}
                            checked={isParentRadioSelected(optionKey)}
                          />
                          <span className="radio-round"></span>
                          <p>{optionKey}</p>
                        </label>
                      </div>
              );
            })}
          </div>
          <p className="error">{controls.error[controls.field_name]}</p>
        </Form.Group>
      </Col>
      {isEditMode || hasValue(optionValue) || hasSavedConditionalValue() ? (
        Object.values(eval(controls.option)[Index])[0]['field_type'] ===
        'radio' ? (
          <Col sm={6}>
            <Form.Group>
              <Form.Label>
                {toSentenceCase(Object.values(eval(controls.option)[Index])[0]?.field_label)}
              </Form.Label>
              <div className="new-form-radio">
                {Object.values(eval(controls.option)[Index])[0]['option'].map(
                  (item, index) => {
                    const nestedOptionKey = Object.keys(item)[0];
                    return (
                      <div key={nestedOptionKey || index} className="new-form-radio-box">
                        <label htmlFor={nestedOptionKey}>
                          <input
                            type={
                              Object.values(eval(controls.option)[Index])[0][
                                'field_type'
                              ]
                            }
                            disabled={props.isDisable ? props.isDisable : false}
                            value={Object.values(item)[0]}
                            name={
                              Object.values(eval(controls.option)[Index])[0][
                                'field_name'
                              ]
                            }
                            id={Object.keys(item)[0]}
                            onClick={(e) => {
                              props.onChange(
                                `${e.target.name} ${props?.field_name}`,
                                e.target.value
                              );
                            }}
                            checked={
                              getSavedConditionalFieldValue(
                                Object.values(eval(controls.option)[Index])[0][
                                  'field_name'
                                ]
                              ) === Object.values(item)[0] ||
                              (Object?.keys(extData)?.length > 0
                                ? extData[
                                    Object.values(
                                      eval(controls.option)[Index]
                                    )[0]['field_name']
                                  ] === Object.values(item)[0]
                                : false)
                            }
                          />
                          <span className="radio-round"></span>
                          <p>{Object.keys(item)[0]}</p>
                        </label>
                      </div>
                    );
                  }
                )}
              </div>
            </Form.Group>
          </Col>
        ) : Object.values(eval(controls.option)[Index])[0]['field_type'] ===
          'dropdown_selection' ? (
          <Col sm={6}>
            <div className="child_info_field sex">
              <span className="form-label">
                {toSentenceCase(Object.values(eval(controls.option)[Index])[0].field_label)}
              </span>
              <div className="d-flex mt-2"></div>
              <div className="btn-radio d-flex align-items-center">
                <Form.Select
                  name={
                    Object.values(eval(controls.option)[Index])[0]?.field_name
                  }
                  value={dropDownValue ? dropDownValue : 'Select'}
                  onChange={(e) => {
                    setDropDownValue(e.target.value);
                    props.onChange(
                      `${
                        Object.values(eval(controls.option)[Index])[0]
                          ?.field_name
                      } ${props?.field_name}`,
                      e.target.value
                    );
                  }}
                >
                  <option>Select </option>
                  {Object.values(eval(controls.option)[Index])[0]['option'].map(
                    (item, index) => {
                      const dropdownOptionKey = Object.keys(item)[0];
                      return (
                          <option key={dropdownOptionKey || index}>{dropdownOptionKey}</option>
                      );
                    }
                  )}
                </Form.Select>
              </div>
              <p>{controls.error[controls.field_name]}</p>
            </div>
          </Col>
        ) : Object.values(eval(controls.option)[Index])[0]['field_type'] ===
          'checkbox' ? (
          <Col sm={6}>
            <div className="child_info_field sex">
              <span>
                {toSentenceCase(Object.values(eval(controls?.option)[Index])[0]?.field_label)}:
              </span>
              <div className="d-flex mt-2"></div>
              <div className="btn-radio d-flex align-items-center">
                {Object.values(eval(controls.option)[Index])[0]['option'].map(
                  (item, index) => {
                    const checkboxOptionKey = Object.keys(item)[0];
                    return (
                      <div key={checkboxOptionKey || index} className="d-flex align-items-center me-3">
                        <label htmlFor={checkboxOptionKey}>
                          {checkboxOptionKey}
                        </label>
                        <Form.Check
                          type="checkbox"
                          className="checktest"
                          name={
                            Object.values(eval(controls.option)[Index])[0]
                              .field_name
                          }
                          id={checkboxOptionKey}
                          value={checkboxOptionKey}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setEvent(e.target.name);
                              setArray((oldData) => {
                                if (oldData) {
                                  return [...oldData, Object.keys(item)[0]];
                                } else {
                                  return [Object.keys(item)[0]];
                                }
                              });
                            } else {
                              setEvent(e.target.name);
                              setArray((oldData) =>
                                oldData?.filter(
                                  (item) => item !== e.target.value
                                )
                              );
                            }
                          }}
                          checked={array?.includes(checkboxOptionKey)}
                        />
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </Col>
        ) : Object.values(eval(controls.option)[Index])[0]['field_type'] ===
          'instruction_text' ? (
          <Col sm={6}>
            <div className="child_info_field">
              <span className="form-label">
                {toSentenceCase(Object.values(eval(controls.option)[Index])[0].field_label)}:
              </span>
              <Form.Control
                as="textarea"
                rows={controls.row ? controls.row : 3}
                name={Object.values(eval(controls.option)[Index])[0].field_name}
                value={
                  getSavedConditionalFieldValue(
                    Object.values(eval(controls.option)[Index])[0].field_name
                  ) || ''
                }
                className="child_input"
                onChange={(e) => {
                  e.preventDefault();
                  props.onChange(
                    `${e.target.name} ${props?.field_name}`,
                    e.target.value
                  );
                }}
              />
            </div>
          </Col>
        ) : Object.values(eval(controls.option)[Index])[0]['field_type'] ===
          'signature' ? (
          <Col sm={6}>
            <Form.Group>
              <Form.Label>
                {toSentenceCase(Object.values(eval(controls.option)[Index])[0].field_label)}
              </Form.Label>
              <SignaturePad
                canvasProps={{
                  style: {
                    background: 'white',
                    border: '1px solid #e5e5e5',
                    width: '310px',
                    minHeight: '65%',
                    display: 'grid',
                  },
                }}
                ref={sigPad}
              />
              <div style={{ marginTop: '5px' }}>
                <Button style={{ minWidth: '70px !important' }} onClick={trim}>
                  Save Signature
                </Button>
                <Button
                  className="theme-light"
                  style={{ minWidth: '70px !important' }}
                  onClick={clear}
                >
                  Clear
                </Button>
              </div>
            </Form.Group>
          </Col>
        ) : Object.values(eval(controls.option)[Index])[0]['field_type'] ===
            'image_upload' ||
          Object.values(eval(controls.option)[Index])[0]['field_type'] ===
            'document_attachment' ? (
          (() => {
            const conditionalField = Object.values(eval(controls.option)[Index])[0];
            const savedFileUrl = getConditionalFieldValue(
              props?.field_data?.fields || {},
              conditionalField.field_name,
              controls?.field_name
            );
            const displayFileUrl = fileList || savedFileUrl || '';

            return (
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>
                    {toSentenceCase(conditionalField.field_label)}
                  </Form.Label>

                  <Form.Control
                    type="file"
                    name={conditionalField.field_name}
                    onChange={async (e) => {
                      let file = e.target.files[0];
                      const url = await uploadFile(file);
                      if (!url) return;
                      setFileList(url);
                      props.onChange(
                        `${e.target.name} ${props?.field_name}`,
                        url,
                        'file'
                      );
                    }}
                  />
                  {displayFileUrl &&
                    conditionalField.field_type === 'document_attachment' && (
                      <h5>
                        {
                          displayFileUrl.split('/')[displayFileUrl.split('/').length - 1]
                        }
                      </h5>
                    )}
                  {displayFileUrl && conditionalField.field_type === 'image_upload' && (
                    <img
                      src={displayFileUrl}
                      alt="image"
                      style={{ width: '100px' }}
                    />
                  )}
                </Form.Group>
              </Col>
            );
          })()
        ) : Object.values(eval(controls.option)[Index])[0]['field_type'] ===
          'text_headings' ? (
          <Col sm={12} className="main-form-text-heading-title">
            <br />
            <Form.Group>
              <Form.Label className="form-style-headings">
                {toSentenceCase(Object.values(eval(controls.option)[Index])[0].field_label)}
              </Form.Label>
            </Form.Group>
          </Col>
        ) : Object.values(eval(controls.option)[Index])[0]['field_type'] ===
          'headings' ? (
          <Col sm={12} className="main-form-heading-title">
            <br />
            <Form.Group>
              <Form.Label className="form-style-headings">
                {toSentenceCase(Object.values(eval(controls.option)[Index])[0].field_label)}
              </Form.Label>
            </Form.Group>
          </Col>
        ) : Object.values(eval(controls.option)[Index])[0]['field_type'] ===
          'sub_headings' ? (
          <>
            <Col sm={12} className="main-form-text-sub-heading-title">
              <br />
              <Form.Group>
                <Form.Label className="form-style-headings">
                  {toSentenceCase(Object.values(eval(controls.option)[Index])[0].field_label)}
                </Form.Label>
              </Form.Group>
            </Col>
          </>
        ) : (
          <>
            {Object.values(eval(controls.option)[Index])[0]?.field_name && (
              <Col sm={6}>
                <Form.Group>
                  <Form.Label>
                    {toSentenceCase(Object.values(eval(controls.option)[Index])[0].field_label)}
                  </Form.Label>
                  <Form.Control
                    type={
                      Object.values(eval(controls.option)[Index])[0].field_type
                    }
                    name={
                      Object.values(eval(controls.option)[Index])[0].field_name
                    }
                    disabled={controls?.isDisable}
                    onChange={(e) => {
                      props.onChange(
                        `${e.target.name} ${props?.field_name}`,
                        e.target.value
                      );
                      setTextInputValue(e.target.value);
                    }}
                    value={
                      getSavedConditionalFieldValue(
                        Object.values(eval(controls.option)[Index])[0].field_name
                      ) ||
                      textInputValue ||
                      ''
                    }
                  />
                </Form.Group>
              </Col>
            )}
          </>
        )
      ) : null}
    </>
  );
};
export default Radio;
